import { Injectable } from '@angular/core';

import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './auth-service';
import { RouterService } from './router-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private authService: AuthService,
        private routerService: RouterService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError(err => this.handleError(err)));
    }

    private handleError(response: HttpErrorResponse): Observable<any> {
        if (response.status === 401) {
            if (this.authService.checksum) {
                this.routerService.setPrevUrl(this.router.url);
                this.router.navigate(['/login'], { state: { loginFirst: true }, replaceUrl: true });
            }
            return throwError({ message: response.error?.error || 'Incorrect login credentials.', status: 401 });
        }
        return throwError(response);
    }
}
